import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import RecaptchaV2 from './RecaptchaV2';

const V2_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY;

function ConfirmationInvitesModal({
    isOpen,
    onClose,
    onConfirm,
    loading = false,
    // Opt-in: the interpreter portal passes this to require a v2 "I'm not a robot" challenge
    // before accepting a job (auto-accept bot protection). Admin callers leave it off → unchanged.
    requireCaptcha = false
}) {
    const [captchaToken, setCaptchaToken] = useState('');

    // Challenge only the Accept action, and only when a v2 key is configured — mirrors the backend
    // no-op without a secret, so a missing key never locks interpreters out of accepting.
    const captchaActive = requireCaptcha && !!V2_SITE_KEY && isOpen === 'accept';

    // Reset the solved token whenever the modal opens/closes so it can't be reused.
    useEffect(() => { setCaptchaToken(''); }, [isOpen]);

    const canConfirm = !loading && (!captchaActive || !!captchaToken);

    return (
        <>

            <Modal isOpen={!!isOpen} toggle={loading ? undefined : onClose} centered>
                <ModalBody>
                    <div className='py-4 px-2'>
                        <h3 className='main_heading'>
                            Are you sure you want to {isOpen}?
                        </h3>
                        {captchaActive && (
                            <div className="mt-3 d-flex justify-content-center">
                                <RecaptchaV2 onToken={setCaptchaToken} />
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="main_button" disabled={!canConfirm} onClick={() => canConfirm && onConfirm(isOpen, captchaToken)}>
                        {loading ? 'Please wait...' : 'Yes'}
                    </button>
                    <button className="table_delete" disabled={loading} onClick={onClose}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationInvitesModal;
